import { useQuery } from '@tanstack/react-query';

import { resolve } from 'api/resolve';

import { useSubscriptionsApi } from '../subscriptions-api';
import { FETCH_USER_PERMISSIONS_QUERY_KEY } from '../subscriptions-query-keys';

export const useUserPermissions = () => {
  const { getPermissions } = useSubscriptionsApi();

  return useQuery({
    queryKey: FETCH_USER_PERMISSIONS_QUERY_KEY,
    queryFn: async () => {
      const result = await resolve(getPermissions());
      return result.permissions;
    }
  });
};
